export const contentTableConfig = {
  title: '欢迎语',
  propList: [
    {prop: 'empId', label: '企微账号', minWidth: '60'},
    {prop: 'corpName', label: '所属主体', minWidth: '60'},
    {prop: 'welcome', label: '欢迎语', minWidth: '80'},
    {prop: 'picUrl', label: '图片', minWidth: '80', slotName: 'picUrl'},
    {prop: 'videoId', label: '视频ID', minWidth: '80', slotName: 'videoId'},
    {prop: 'upVideoTime', label: '视频状态', minWidth: '80', slotName: 'upVideoTime'},
    {prop: 'updateTime', label: '更新时间', minWidth: '60'},
    {
      label: '操作',
      minWidth: '60',
      slotName: 'handler'
    }
  ],
  showIndexColumn: false,
  showSelectColumn: false,
  action: process.env.VUE_APP_BASE_URL + '/main/welcome/dataImport'
}
